import { render, staticRenderFns } from "./RosterRoles.vue?vue&type=template&id=398c370f&scoped=true"
import script from "./RosterRoles.vue?vue&type=script&lang=js"
export * from "./RosterRoles.vue?vue&type=script&lang=js"
import style0 from "./RosterRoles.vue?vue&type=style&index=0&id=398c370f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398c370f",
  null
  
)

export default component.exports